var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpScroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.01,
    height: 37.73,
    viewBox: "0 0 48.01 37.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M40.86,31.14A13.19,13.19,0,0,0,27.68,44.31V55.69a13.18,13.18,0,1,0,26.35,0V44.31A13.19,13.19,0,0,0,40.86,31.14ZM30.68,44.31a10.18,10.18,0,0,1,8.68-10.05V45.39H30.68ZM51,55.69a10.18,10.18,0,1,1-20.36,0v-7.3H51Zm0-10.3H42.36V34.26A10.18,10.18,0,0,1,51,44.31Z",
    transform: "translate(-27.68 -31.14)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M73.88,54.94l-4.57,3.75V39l4.57,3.74A1.11,1.11,0,1,0,75.29,41L69,35.89a1.13,1.13,0,0,0-1.4,0L61.22,41a1.11,1.11,0,0,0-.17,1.55,1.12,1.12,0,0,0,.87.42,1.07,1.07,0,0,0,.69-.25l4.49-3.61v19.4l-4.49-3.6a1.11,1.11,0,1,0-1.39,1.72l6.4,5.15a1.12,1.12,0,0,0,1.4,0l6.27-5.14a1.11,1.11,0,0,0-1.41-1.72Z",
    transform: "translate(-27.68 -31.14)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpScroll);
export default __webpack_public_path__ + "static/media/help_scroll.bb23a3b62bc3ea9c1895517c5c7c3bec.svg";
export { ForwardRef as ReactComponent };